<template>
  <div class="field-wrapper">
    <div
      class="field-country-telephone-item"
      :class="{ error: field.hasError }"
    >
      <VuePhoneNumberInput
        v-model="phone"
        v-bind="props"
        :no-example="true"
        :required="field.required"
        :disabled="field.readOnly != undefined ? field.readOnly : false"
        @phone-number-focused="field.hasError = false"
        @update="fieldChanged"
      />
    </div>
  </div>
</template>

<script>
//Importing libraries
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  name: "CountryTelephoneField",
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  watch: {
    field: {
      immediate: true,
      deep: true,
      handler() {
        this.initData();
      },
    },
  },
  data() {
    return {
      fieldInit: false,
      initPhone: {},
      phone: null,
      props: {
        noExample: true,
        defaultCountryCode: null,
        translations: {
          countrySelectorLabel: "Country code",
          countrySelectorError: "Error",
          phoneNumberLabel: "Enter your phone",
        },
      },
    };
  },
  components: {
    VuePhoneNumberInput,
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      if (this.field)
        this.props.translations.phoneNumberLabel = this.field.placeholder;

      if (this.field.value.number) {
        this.phone = this.field.value.number;
        this.props.defaultCountryCode = this.field.value.countryCode;
      } else {
        delete this.props.defaultCountryCode;
        this.props.fetchCountry = true;
      }
    },

    fieldChanged(phone) {
      if (this.fieldInit) {
        this.field.value = {
          countryCode: phone.countryCode,
          countryCallingCode: phone.countryCallingCode,
          number: phone.nationalNumber,
        };
        this.$emit("fieldChanged", phone.isValid);
      }
      this.fieldInit = true;
    },
  },
};
</script>

<style scoped lang="scss">
input[readonly] {
  cursor: default;
  border: 1px solid #e7e6ef;
}

/deep/ {
  .country-selector,
  .input-tel {
    height: auto;
    min-height: auto;
  }

  .select-country-container {
    min-width: 0 !important;
    max-width: none !important;
    width: 6.5em !important;
    flex: none !important;
  }

  .input-tel__label {
    color: $greyColor !important;
    top: 6px;
    left: 32px;
  }

  .country-selector__input {
    padding-top: 18px !important;
  }

  .country-selector__input,
  .input-tel__input {
    display: block;
    font-family: $bodyFont;
    font-size: $normalFontSize;
    font-weight: 500;
    outline: none;
    color: $darkBlackColor;
    padding: 0.75rem 1.15rem;
    border: 1px solid $inputBorderColor;
    border-radius: 0.5rem !important;
    margin-left: 0;
    width: calc(100%);
    -webkit-appearance: none;
    transition: all $transitionSpeed;
    box-shadow: none !important;
    height: auto;

    &::placeholder {
      font-size: $smallFontSize;
      font-weight: 400;
      color: lighten($darkBlackColor, 50%);
    }

    &:not(.no-country-selector) {
      border-top-left-radius: 0.5rem !important;
      border-bottom-left-radius: 0.5rem !important;
    }

    &:hover,
    &:focus {
      border-color: $darkBlackColor;
    }
  }

  .input-tel.has-value .input-tel__input {
    padding-top: 18px !important;
  }

  .country-selector__input {
    margin-left: 0;
    width: calc(100%);
  }

  .country-selector__label {
    color: $greyColor !important;
    top: 6px;
  }

  .country-selector__country-flag,
  .country-selector__toggle {
    transform-origin: center;
  }

  .country-selector__country-flag {
    margin-top: 1px;
  }
}

.error /deep/ {
  .country-selector__input,
  .input-tel__input {
    border-color: $redColor !important;
  }
}

@media only screen and (max-width: 800px) {
  /deep/ {
    .country-selector__input,
    .input-tel__input {
      font-size: $smallFontSize;

      &::placeholder {
        font-size: $smallFontSize;
      }
    }
  }
}
</style>